<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ods-dialog>
  <ods-dialog-header [heading]="headline()" (closeClicked)="close()" />
  <ods-dialog-content>
    <p data-test-id="decision-dialog-sub-headline">{{ subHeadline() }}</p>
    @if (content(); as content) {
      <p data-test-id="decision-dialog-content">
        <span class="font-bold">{{ content.preTextLabel }}</span
        >: {{ content.main }}
      </p>
    }
  </ods-dialog-content>
  <ods-dialog-footer closeButtonText="Abbrechen" (closeClicked)="close()">
    <odc-button-with-spinner
      [stateResource]="stateResource()"
      [text]="applyButton().label"
      dataTestId="decision-dialog-apply-button"
      [destructive]="applyButton().destructive"
      [icon]="applyButton().iconName"
      (clicked)="apply.emit()"
    />
  </ods-dialog-footer>
</ods-dialog>
